import { Dialog } from '@angular/cdk/dialog';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTES } from 'libs/common/src/lib/constants/routes.constants';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { CommonService } from 'libs/common/src/lib/service/common.service';
import { ConfirmationPopupWithFormComponent } from 'libs/shared/ui-components/src/lib/confirmation-popup-with-form/confirmation-popup-with-form.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-asset-type',
  templateUrl: './add-asset-type.component.html',
  styleUrls: ['./add-asset-type.component.scss'],
})
export class AddAssetTypeComponent implements OnInit {
  assetTypeForm: FormGroup;
  isEditMode: boolean = false;
  assetDetails: any;
  accordionState: boolean[] = [false, false, false];
  purchaseDateValues: string[] = [];
  purchaseDateUnits: string[] = [];
  purchaseCostValues: string[] = [];
  editFormData: any;
  purchaseCostUnits: string[] = [];
  warrantyValues: string[] = [];
  warrantyUnits: string[] = [];
  invoiceNumberValues: string[] = [];
  invoiceNumberUnits: string[] = [];
  locations: any;
  issuesValues: string[] = [];
  selectedCount: number = 0;
  groupAccordionState: { [key: string]: boolean } = {};
  groupedProperties: { groupName: string; properties: any[] }[] = [];
  @Output() formSubmitted = new EventEmitter<void>();
  groupMenuState: { [key: string]: boolean } = {};
  properties: {
    property: string;
    value: string[];
    unit: string[];
    isRequired: boolean;
    checked: boolean;
    sequence?: number;   // add optional
    category?: string;  
  }[] = [];
  isDisabled: boolean = true;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private commonHttpService: CommonHttpService,
    private commonService: CommonService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private cdr: ChangeDetectorRef,
    private dialog: Dialog
  ) {
    this.assetTypeForm = this.fb.group({
      name: ['', Validators.required],
      assetTypeCode: ['', Validators.required],
      id: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.isEditMode = false;
    this.route.queryParams.subscribe((params) => {
      this.assetTypeForm.patchValue({
        name: params['name'] || '',
        assetTypeCode: params['assetTypeCode'] || '',
        id: params['id'] || '',
      });
      this.isEditMode = params['editMode'] === 'true';
    });
    this.getLocations();
    if (this.isEditMode) {
      this.fetchAssetDetails();
    }else {
    this.assetDetails = { configs: [], categories: [] };
  }
  }

  fetchAssetDetails() {
    const formData = this.assetTypeForm.value;
    const id = formData.id;
    this.commonHttpService.getAssetTypeDetails(id).subscribe({
      next: (response: any) => {
        this.assetDetails = response.data;
        this.isEditMode = true;
        this.groupedProperties = this.groupConfigsByCategory(
          this.assetDetails.configs,
          this.assetDetails.categories
        );
      },
      error: (error: any) => {
        console.error('Error fetching asset details:', error);
      },
    });
  }
  groupConfigsByCategory(
    configs: any[],
    categories: any
  ): { groupName: string; properties: any[] }[] {
    const grouped = configs.reduce((acc: any, config: any) => {
      const category = categories?.find(
        (category: any) => category.name === config.category
      );

      if(!category){
        return acc;
      }

      if (!acc[category?.displayName]) {
        acc[category.displayName] = {
          groupName: category.displayName,
          sequence: category.sequence,
          properties: [],
        };
      }
      acc[category.displayName].properties.push(config);
      return acc;
    }, {} as Record<string, { groupName: string; sequence: number; properties: any[] }>);

    return Object.values(grouped).sort(
    (a: any, b: any) => a.sequence - b.sequence
  )as { groupName: string; sequence: number; properties: any[] }[];
  }
  toggleGroupMenu(groupName: string): void {
    this.groupMenuState[groupName] = !this.groupMenuState[groupName];
  }
  closeGroup(groupName: string) {
    this.groupMenuState[groupName] = !this.groupMenuState[groupName];
  }
drop(event: CdkDragDrop<any[]>, targetGroup: any | null) {
  if (event.previousContainer === event.container) {
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
  } else {
    transferArrayItem(
      event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
  }

  this.updateSequences();
  this.cdr.detectChanges();
}

updateSequences() {
  this.groupedProperties.forEach(group => {
    group.properties.forEach((prop, index) => {
      prop.sequence = index + 1; 
      prop.category = group.groupName; 
    });
  });

  this.properties.forEach((prop, index) => {
    prop.sequence = index + 1;
    prop.category = ''; 
  });
  this.isDisabled = false;
}

  onAddProperty(): void {
    const formData = {
      header: 'Add Property',
      description: 'Please enter the property and unit, value(s) if any',
      image: 'cautionImage',
      form: {
        confirmationForm: new UntypedFormGroup({
          property: new UntypedFormControl('', [Validators.required]),
          value: new UntypedFormControl(''),
          unit: new UntypedFormControl(''),
        }),
      },
      includeUnits: true,
      includeIsRequired: true,
      fields: [
        {
          field: 'text-field',
          controlName: 'property',
          placeholder: 'E.g., RAM size',
          label: 'Property',
          isRequired: true
        },
        {
          field: 'text-fields',
          controlName: 'value',
          placeholder: 'E.g., 4, 8, 16 etc.',
          label: 'Value(s)',
        },
      ],
      primaryBtn: 'Add',
      isEditMode: this.isEditMode,
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: formData,
    });
    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        this.properties.push({
          property: result.property,
          value: this.normalize(result.value),
          unit: this.normalize(result.unit),
          isRequired: result.isRequired,
          checked: false,
        });
      }
      this.isDisabled = false;
      this.cdr.detectChanges();
    });
  }

  onEditProperty(groupIndex: number | null, propertyIndex: number): void {
    let property: any;
    if (groupIndex !== null) {
      property = this.groupedProperties[groupIndex].properties[propertyIndex];
    } else {
      property = this.properties[propertyIndex];
    }

    if (!property) {
      return;
    }

    this.editFormData = {
      header: 'Edit Property',
      description: 'Modify the property details',
      image: 'editImage',
      form: {
        confirmationForm: new FormGroup({
          property: new FormControl(property.property || property.displayName, [
            Validators.required,
          ]),
          value: new FormControl(
            property.value?.join(', ') || property.values?.join(', ')
          ),
          unit: new FormControl(
            property.unit?.join(', ') || property.units?.join(', ')
          ),
          isRequired: new FormControl({ value: property.isRequired }),
        }),
      },
      includeUnits: true,
      includeIsRequired: true,
      isTextFieldDisabled: property.name ==='warranty',
      fields: [
        {
          field: 'text-field',
          controlName: 'property',
          placeholder: 'Property Name',
          label: 'Property',
        },
        {
          field: 'text-fields',
          controlName: 'value',
          placeholder: 'Values (comma-separated)',
          label: 'Value(s)',
        },
        {
          field: 'checkbox',
          controlName: 'isRequired',
          label: 'Required',
        },
      ],
      primaryBtn: 'Save',
      isEditMode: this.isEditMode,
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: this.editFormData,
    });

    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        const updatedProperty = {
          property: result.property,
          value: this.normalize(result.value),
          unit: this.normalize(result.unit),
          isRequired: property.isRequired,
          checked: property.checked,
        };

        if (groupIndex !== null) {
          this.groupedProperties[groupIndex].properties[propertyIndex] = updatedProperty;
        } else {
          this.properties[propertyIndex] = updatedProperty;
        }
      }
      this.isDisabled = false;
    });
  }
  onEditDetail(fieldName: string): void {
    let existingValues: string[] = [];
    let existingUnits: string[] = [];
    switch (fieldName) {
      case 'Purchase Cost':
        existingValues = this.purchaseCostValues;
        existingUnits = this.purchaseCostUnits;
        break;
      case 'Warranty':
        existingValues = this.warrantyValues;
        existingUnits = this.warrantyUnits;
        break;
      case 'Invoice Number':
        existingValues = this.invoiceNumberValues;
        existingUnits = this.invoiceNumberUnits;
        break;
    }

    const requiredValue = (fieldName === 'Purchase Cost') || (fieldName === 'Warranty') || (fieldName === 'Invoice Number');

    const formData = {
      header: `Edit ${fieldName}`,
      description: `Edit the ${fieldName} and add value(s) and unit(s)`,
      image: 'cautionImage',
      form: {
        confirmationForm: new FormGroup({
          property: new FormControl(fieldName, [Validators.required]),
          value: new FormControl(existingValues.join(', '), [Validators.required]),
          unit: new FormControl(existingUnits.join(', '), [Validators.required]),
          isRequired: new FormControl(requiredValue),
        }),
      },
      includeUnits: true,
      includeIsRequired: true,
      isTextFieldDisabled: fieldName === 'Warranty',
      fields: [
        {
          field: 'text-field',
          controlName: 'property',
          placeholder: 'Property Name',
          label: 'Property',
        },
        {
          field: 'text-fields',
          controlName: 'value',
          placeholder: 'Add values',
          label: 'Value(s)',
        },
      ],
      primaryBtn: 'Save',
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: formData,
    });

    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        switch (fieldName) {
          case 'Purchase Cost':
            this.purchaseCostValues = this.normalize(result.value)
            this.purchaseCostUnits = this.normalize(result.unit)
            break;
          case 'Warranty':
            this.warrantyValues = this.normalize(result.value)
            this.warrantyUnits = this.normalize(result.unit)
            break;
          case 'Invoice Number':
            this.invoiceNumberValues =this.normalize(result.value)
            this.invoiceNumberUnits = this.normalize(result.unit)
            break;
        }
      }
      this.isDisabled = false;
    });
  }
  toggleAccordion(index: number): void {
    this.accordionState[index] = !this.accordionState[index];
  }

  getLocations() {
    this.commonHttpService.getLocations().subscribe((res: any) => {
      if (res && res.data) {
        this.locations = res.data;
      } else {
        this.locations = [];
      }
    });
  }
  toggleCheckbox(index: number): void {
    this.properties[index].checked = !this.properties[index].checked;
    this.updateSelectedCount();
  }

  updateSelectedCount(): void {
    this.selectedCount = this.properties.filter((prop) => prop.checked).length;
  }

  clearSelection(): void {
    this.properties.forEach((prop) => (prop.checked = false));
    this.updateSelectedCount();
  }
  onGroupSelection(): void {
    const formData = {
      header: 'Group Selection',
      description: 'Enter details for the group selection',
      image: 'cautionImage',
      form: {
        confirmationForm: new UntypedFormGroup({
          groupName: new UntypedFormControl('', [Validators.required]),
        }),
      },
      fields: [
        {
          field: 'text-field',
          controlName: 'groupName',
          placeholder: 'Enter group name',
          label: 'Group Name',
        },
      ],
      primaryBtn: 'Save',
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: formData,
    });

    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        const selectedProperties = this.properties.filter(
          (prop) => prop.checked
        );
        this.groupedProperties.push({
          groupName: result.groupName,
          properties: selectedProperties,
        });
        this.properties = this.properties.filter((prop) => !prop.checked);
        this.clearSelection();
      }
      this.isDisabled = false;
    });
  }
  toggleGroupAccordion(groupName: string): void {
    this.groupAccordionState[groupName] = !this.groupAccordionState[groupName];
  }
  onEditIssues(): void {
    const formData = {
      header: 'Edit Issues',
      description: 'Please enter the issue details',
      image: 'cautionImage',
      form: {
        confirmationForm: new UntypedFormGroup({
          property: new UntypedFormControl('Issues', [Validators.required]),
          value: new UntypedFormControl(this.issuesValues.join(', '), [
            Validators.required,
          ]),
        }),
      },
      fields: [
        {
          field: 'text-field',
          controlName: 'property',
          placeholder: 'Property Name',
          label: 'Property',
        },
        {
          field: 'text-fields',
          controlName: 'value',
          placeholder: 'Enter issue values',
          label: 'Issue Value(s)',
        },
      ],
      primaryBtn: 'Save',
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: formData,
    });

    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        this.issuesValues = this.normalize(result.value)
      }
      this.isDisabled = false;
    });
  }

  getNextSequenceForOthers(): number {
    const maxGroupedSequence = this.groupedProperties
      .flatMap((group) =>
        group.properties
          .filter((prop) => prop?.category?.toLowerCase() === 'others')
          .map((prop) => prop.sequence || 0)
      )
      .reduce((max, sequence) => Math.max(max, sequence), 0);
    const maxPropertiesSequence = this.properties
      .map((prop, index) => index + 1)
      .reduce((max, sequence) => Math.max(max, sequence), 0);
    return Math.max(maxGroupedSequence, maxPropertiesSequence) + 1;
  }
  onSubmit() {
    if (this.assetTypeForm.valid) {
      const formData = this.assetTypeForm.value;
      const nextSequenceForOthers = this.getNextSequenceForOthers();
      const categoriesMap = new Map();
const existingSequences = new Map(
  (this.assetDetails?.categories || []).map((c: any) => [c.name, c.sequence])
);
const displayNameToNameMap = new Map(
  (this.assetDetails?.categories || []).map((c: any) => [
    c.displayName,  
    c.name,         
  ])
);

this.groupedProperties.forEach((group, index) => {
  if (!categoriesMap.has(group.groupName)) {
    const existingSeq = existingSequences.get(displayNameToNameMap.get(group.groupName));
    const internalName = displayNameToNameMap.get(group.groupName) ?? group.groupName;
    categoriesMap.set(group.groupName, {
      name: group.groupName,
      sequence: existingSeq ?? index + 1,
    });
  }
});

if (this.properties.length > 0 && !categoriesMap.has('Others')) {
  const existingSeq = existingSequences.get('others');
  const internalOthers = displayNameToNameMap.get('Others') ?? 'others';
categoriesMap.set('Others', {
  name: 'Others',
  sequence: existingSeq ?? categoriesMap.size + 1,
});
} else if (categoriesMap.has('Others')) {
  const existingSeq = existingSequences.get('Others');
  if (existingSeq) {
    categoriesMap.set('Others', {
      ...categoriesMap.get('Others'),
      sequence: existingSeq,
    });
  }
}

if (!categoriesMap.has('Location')) {
  const existingSeq = existingSequences.get('Location');
  const internalLocation = displayNameToNameMap.get('Location') ?? 'location';
categoriesMap.set('Location', {
  name: 'Location',
  sequence: existingSeq ?? categoriesMap.size + 1,
});
}

if (!categoriesMap.has('Purchase Details')) {
  const existingSeq = existingSequences.get('purchaseDetails');
  const internalPurchase = displayNameToNameMap.get('Purchase Details') ?? 'purchaseDetails';
categoriesMap.set('Purchase Details', {
  name: 'Purchase Details',
  sequence: existingSeq ?? categoriesMap.size + 1,
});
}
      const categories = Array.from(categoriesMap.values());
      const categoryNameMap = new Map<string,string>();
categories.forEach(c => {
  categoryNameMap.set(c.name.toLowerCase(), c.name);
  categoryNameMap.set(c.name.toLowerCase(), c.name);
});
const purchaseDetailsAlreadyExist = this.groupedProperties.some(g =>
  g.groupName.toLowerCase() === 'purchase details' &&
  g.properties.some(p => p.property?.toLowerCase() === 'warranty')
);
const displayToInternal = new Map(
  (this.assetDetails?.categories || []).map((c: any) => [
    c.displayName.toLowerCase(), 
    c.name                       
  ])
);

const existingConfigsMap = new Map<string, any>();
(this.assetDetails?.configs ?? []).forEach((c: any) => {
  existingConfigsMap.set(`${c.category.toLowerCase()}|${c.displayName.toLowerCase()}`, c);
});

const maxSeqPerCategory = new Map<string, number>();
(this.assetDetails?.configs ?? []).forEach((c: any) => {
  const cat = c.category;
  const currentMax = maxSeqPerCategory.get(cat) ?? 0;
  if (c.sequence > currentMax) maxSeqPerCategory.set(cat, c.sequence);
});

let configs: any[] = [];

for (const group of this.groupedProperties) {
  for (const [index, prop] of group.properties.entries()) {
    const catInternal = displayToInternal.get(group.groupName?.toLowerCase?.() ?? '') ?? group.groupName ?? '';
    const propName = prop.name ?? prop.property ?? prop.displayName ?? '';

    const key = `${String(catInternal).toLowerCase()}|${String(propName).toLowerCase()}`;
    const existing = existingConfigsMap.get(key);

    configs.push({
      name: prop?.displayName || existing?.name || propName,
      values: prop.values || prop.value,
      valueType: prop.valueType || 'string',
      isRequired: prop.isRequired,
      category: group.groupName,
      units: prop.units || prop.unit,
      sequence: existing?.sequence || undefined 
    });
  }
}

for (const [index, prop] of this.properties.entries()) {
  const catInternal = 'others';
  const key = `${catInternal}|${prop.property.toLowerCase()}`;
  const existing = existingConfigsMap.get(key);

  configs.push({
    name: existing?.name || prop.property,
    values: prop.value,
    valueType: 'string',
    isRequired: prop.isRequired,
    category: 'Others',
    units: prop.unit,
    sequence: existing?.sequence || undefined
  });
}

if (!purchaseDetailsAlreadyExist) {
  const catInternal = 'purchaseDetails';
  for (const [i, p] of this.purchaseDetailsToConfigs().entries()) {
    const key = `${catInternal}|${p.name.toLowerCase()}`;
    const existing = existingConfigsMap.get(key);
    configs.push({
      ...p,
      category: 'Purchase Details',
      name: (existing?.displayName || existing?.name || p.name === 'warranty') ? 'Warranty' : existing?.displayName || existing?.name || p.name,
      sequence: 2
    });
  }
}

const banned = ['purchase cost', 'purchasecost', 'invoice number', 'invoicenumber'];
configs = configs.filter(c => !banned.includes((c.name || '').toLowerCase()));

const nextSeq = new Map<string, number>(maxSeqPerCategory);

configs.forEach(c => {
  if (c.sequence == null) {
    const current = nextSeq.get(c.category) ?? 0;
    c.sequence = current + 1;
    nextSeq.set(c.category, current + 1);
  }
});
// duplicate category sequences
const usedCatSeq = new Set<number>();
for (const c of categories) {
  if (usedCatSeq.has(c.sequence)) {
    let seq = c.sequence;
    while (usedCatSeq.has(seq)) seq++;
    c.sequence = seq;
  }
  usedCatSeq.add(c.sequence);
}

// missing name fields
configs.forEach(c => {
  if (!c.name || c.name.trim() === '') {
    c.name = c.property ?? 'Unnamed Property';
  }
});

// duplicate config sequences per category
const seqPerCat = new Map<string, Set<number>>();
for (const cfg of configs) {
  if (!seqPerCat.has(cfg.category)) seqPerCat.set(cfg.category, new Set());
  const used = seqPerCat.get(cfg.category)!;
  if (used.has(cfg.sequence)) {
    let seq = cfg.sequence;
    while (used.has(seq)) seq++;
    cfg.sequence = seq;
  }
  used.add(cfg.sequence);
}
const hasWarranty = configs.some(
  c => (c.name || '').toLowerCase() === 'warranty'
);
if (!this.isEditMode && !hasWarranty) {
  configs.push({
    name: 'Warranty',
    values: [],
    valueType: 'string',
    isRequired: true,
    category: 'Purchase Details',
    units: [],
    sequence: 2
  });
}
configs = configs.map(cfg => {
  if (cfg.name && cfg.name.toString().toLowerCase() === 'warranty') {
    return {
      ...cfg,
      name: 'Warranty'
    };
  }
  return cfg;
});
      const payload = {
        name: formData.name,
        assetTypeCode: formData.assetTypeCode,
        categories,
        configs: configs,
      };

      this.commonHttpService
        .submitAssetType(formData.id, payload)
        .subscribe({
          next: (response) => {
            this.formSubmitted.emit();
            this.router.navigate([ROUTES.MANAGE_WORKSPACE_OWNER]);
            this.toastrService.success(
              'Asset type details added successfully.',
              '',
              {
                toastClass: 'toaster-wrapper',
              }
            );
          },
          error: (error) => {
            const errorMsg = error?.error?.error?.errorList[0]?.msg || error?.error?.error?.errorList || 'An error occurred!';
            this.toastrService.error(errorMsg, '', {
              toastClass: 'toaster-wrapper',
            });
          }
        });

    }
  }

  filterRedundantSequences(data: any[]): any[] {
    const uniqueConfigs = new Map();

    data.forEach((item) => {
      const normalizedName = item.name.replace(/\s+/g, '').toLowerCase();
      const key = `${normalizedName}-${item.category.toLowerCase()}`;

      if (!uniqueConfigs.has(key)) {
        uniqueConfigs.set(key, item);
      } else {
        const existingItem = uniqueConfigs.get(key);
        if (item?.values.length > 0 && existingItem.values.length === 0) {
          uniqueConfigs.set(key, item);
        }
      }
    });

    return Array.from(uniqueConfigs.values());
  }
  purchaseDetailsToConfigs() {
    const result: any[] = [];

  if (this.purchaseCostValues.length || this.purchaseCostUnits.length) {
    result.push({
      name: 'Purchase Cost',
      values: this.purchaseCostValues,
      valueType: 'string',
      isRequired: true,
      sequence: 1,
      category: 'Purchase Details',
      units: this.purchaseCostUnits,
    });
  }

  if (this.warrantyValues.length || this.warrantyUnits.length) {
    result.push({
      name: 'Warranty',
      values: this.warrantyValues,
      valueType: 'string',
      isRequired: true,
      sequence: 2,
      category: 'Purchase Details',
      units: this.warrantyUnits,
    });
  }

  if (this.invoiceNumberValues.length || this.invoiceNumberUnits.length) {
    result.push({
      name: 'Invoice Number',
      values: this.invoiceNumberValues,
      valueType: 'string',
      isRequired: true,
      sequence: 3,
      category: 'Purchase Details',
      units: this.invoiceNumberUnits,
    });
  }

  return result;
  }

  addPropertyToGroup(groupName: string): void {
    const formData = {
      header: 'Add Property to Group',
      description: 'Add a property to the group',
      image: 'cautionImage',
      form: {
        confirmationForm: new FormGroup({
          groupName: new FormControl(groupName, [Validators.required]),
          property: new FormControl('', [Validators.required]),
          value: new FormControl(''),
          unit: new FormControl(''),
        }),
      },
      includeUnits: true,
      includeIsRequired: true,
      fields: [
        {
          field: 'text-field',
          controlName: 'property',
          placeholder: 'E.g., RAM size',
          label: 'Property',
        },
        {
          field: 'text-fields',
          controlName: 'value',
          placeholder: 'E.g., 4, 8, 16 etc.',
          label: 'Value(s)',
        },
      ],
      primaryBtn: 'Add',
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: formData,
    });

    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        const group = this.groupedProperties.find(
          (g) => g.groupName === groupName
        );
        if (group) {
          group.properties.push({
            property: result.property,
            value: this.normalize(result.value),
            unit:this.normalize(result.unit),
            isRequired: result.isRequired,
            checked: false,
          });
        }
      }
      this.isDisabled= false;
    });
  }

  renameGroup(groupName: string): void {
    const formData = {
      header: 'Rename Group',
      description: 'Enter a new name for the group',
      image: 'cautionImage',
      form: {
        confirmationForm: new FormGroup({
          groupName: new FormControl(groupName, [Validators.required]),
        }),
      },
      fields: [
        {
          field: 'text-field',
          controlName: 'groupName',
          placeholder: 'Enter new group name',
          label: 'Group Name',
        },
      ],
      primaryBtn: 'Save',
    };

    const dialogRef = this.dialog.open(ConfirmationPopupWithFormComponent, {
      panelClass: 'center-dialog-box',
      backdropClass: 'backdrop',
      disableClose: true,
      width: '50%',
      data: formData,
    });

    dialogRef.closed.subscribe((result: any) => {
      if (result) {
        const group = this.groupedProperties.find(
          (g) => g.groupName === groupName
        );
        if (group) {
          group.groupName = result.groupName;
        }
      }
      this.isDisabled = false;
    });
  }
  getString(array: string[]) {
    return array.join(', ');
  }
  get submitDisabled(): boolean {
    if (!this.isDisabled) {
      return false;
    }
    return this.isEditMode && !this.editFormData?.form?.confirmationForm?.dirty;
  }
  normalize = (v: any) =>
  Array.isArray(v)
    ? v.filter(x => x.trim() !== '')  
    : (v && v.toString().trim() !== '' ? [v] : []);
}
